import React, { Component } from 'react';
import { connect } from 'react-redux';
import { VersionMismatch } from 'services/BaseService';
import { handleVersionMismatch } from 'actions/versionSync';

import StoryletService from 'services/StoryletService';

import sortEligibleFriends from './sortEligibleFriends';
import ActComponent from './ActComponent';
import { IAppState } from 'types/app';
import { IEligibleFriend } from 'types/storylet';


interface Props extends ReturnType<typeof mapStateToProps> {
  dispatch: Function,
}

interface State {
  eligibleFriends: IEligibleFriend[],
  ineligibleContacts: { name: string, qualifies: string, correctInstance: string, youQualify: string }[],
  selectedContactId?: number,
}

class ActContainer extends Component<Props, State> {
  static displayName = 'ActContainer';

  mounted = false;

  state = {
    eligibleFriends: [],
    ineligibleContacts: [],
    selectedContactId: undefined,
  };

  componentDidMount = () => {
    this.mounted = true;
    const { eligibleFriends } = this.props.socialAct?.inviteeData ?? { eligibleFriends: [] };
    this.setState({ eligibleFriends });
    // Update ineligible contacts
    this.fetchIneligibleContacts();

    // Try and set something useful as the default on mount
    if (eligibleFriends.length) {
      this.setState({ selectedContactId: eligibleFriends[0].id });
    }
  };

  componentWillUnmount = () => {
    this.mounted = false;
  };

  handleAddContact = ({ addedFriendId, eligibleFriends }: { addedFriendId: number, eligibleFriends: any[] }) => {
    // Update state with sorted list of eligible friends
    this.setState({ eligibleFriends: [...eligibleFriends.sort(sortEligibleFriends)] });
    // Go get ineligible contacts (they'll update asynchronously)
    this.fetchIneligibleContacts();
    // Try to find the added friend in the updated list of eligible friends and select them if so
    if (eligibleFriends.findIndex(friend => friend.id === addedFriendId) >= 0) {
      this.setState({ selectedContactId: addedFriendId });
    }
  };

  handleSelectContact = (e: any) => {
    // Check whether the ID we've been given is an eligible friend
    const { eligibleFriends } = this.state;

    const id = Number(e.target.value);

    // @ts-ignore
    if (eligibleFriends.find(_ => _.id === id)) {
      this.setState({ selectedContactId: id });
    }
  };

  fetchIneligibleContacts = async () => {
    const { dispatch } = this.props;
    const id = this.props.socialAct?.branch.id;
    if (!id) {
      return;
    }
    try {
      // Fetch this branch's ineligible contacts from the server
      const { data: { ineligibleContacts } } = await new StoryletService().fetchIneligibleContacts(id); // Update state
      if (this.mounted) {
        this.setState({ ineligibleContacts });
      }
    } catch (e) {
      if (e instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(e));
        return;
      }
      throw e;
    }
  };

  render = () => {
    const branch = this.props.socialAct?.branch;
    const rootEventId = this.props.storylet?.id;
    if (!branch || !rootEventId) {
      return null;
    }

    const {
      eligibleFriends,
      ineligibleContacts,
      selectedContactId,
    } = this.state;

    return (
      <ActComponent
        branch={branch}
        eligibleFriends={eligibleFriends}
        ineligibleContacts={ineligibleContacts}
        onAddContact={this.handleAddContact}
        onSelectContact={this.handleSelectContact}
        rootEventId={rootEventId}
        selectedContactId={selectedContactId}
      />
    );
  }
}

const mapStateToProps = ({ storylet: { socialAct, storylet } }: IAppState) => ({ socialAct, storylet });

export default connect(mapStateToProps)(ActContainer);